import {Component} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  ACCOUNT_LOGIN_ROUTE,
  DEFAULT_ROUTE_CONSTANT,
  DESTINATION_KEY_CONSTANT,
  LOGIN_OBJECT_KEY_CONSTANT,
  PRODUCT_KEY_CONSTANT,
} from '../constants/routes.constant';
import {ALL_AUTH_OBJECT_KEY, SESSION_TOKEN_KEY,} from '../constants/local-storage.constant';
import {FirebaseAuthService} from '../services/firebase-auth.service';
import {mergeMap} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.scss'],
    standalone: false
})
export class SignoutComponent {
  private productName!: string;
  private destination!: string;
  private loginObject!: string;
  private readonly productNameKey: string = PRODUCT_KEY_CONSTANT;
  private readonly destinationKey: string = DESTINATION_KEY_CONSTANT;
  private readonly loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  public queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
  };

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar,
    private readonly activatedRoute: ActivatedRoute,
    private readonly firebaseService: FirebaseAuthService
  ) {}

  ngOnInit() {
    this.productName = this.activatedRoute.snapshot.queryParamMap.get(
      this.productNameKey
    )!;
    this.destination = this.activatedRoute.snapshot.queryParamMap.get(
      this.destinationKey
    )!;
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
      this.loginObjectKey
    )!;

    this.queryParams = {
      [this.productNameKey]: this.productName,
      [this.destinationKey]: this.destination,
      [this.loginObjectKey]: this.loginObject,
    };

    if (!this.productName || !this.destination) {
      this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
        queryParams: this.queryParams,
      });
    }
  }

  ngAfterViewInit() {
    this.firebaseService
      .signOut()
      .pipe(
        mergeMap(() => {
          return this.authenticationService.destroyAuthentication();
        })
      )
      .subscribe({
        next: () => {
          this.goAway();
        },
        error: (error: HttpErrorResponse) => {
          if (!error.status || error.status === 400) {
            this.goAway();

            return;
          }

          this.snackBar.open('An error occurred!', 'close', {
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: [
              'bg-danger',
              'text-white',
              'rounded-3e',
              'modified-snackbar',
            ],
          });
        },
      });
  }

  public cleanUpKeys() {
    localStorage.removeItem(SESSION_TOKEN_KEY);
    localStorage.removeItem(ALL_AUTH_OBJECT_KEY);
  }

  public goAway() {
    this.cleanUpKeys();
    this.router.navigate(['/', ...ACCOUNT_LOGIN_ROUTE.split('/')], {
      queryParams: this.queryParams,
    });
  }
}
